export { default as ContentfulImage } from './contentfulImage'



// WEBPACK FOOTER //
// ./src/components/contentful/image/index.js